import axios from "axios";

export const fetchClients = async ({ page, search, per_page, sort }) => {
  let currentPage = page || 1;
  let perPage = per_page || 10; // for test, just delete me after
  let searchValue = search || "";
  let response;
  try {
    response = await axios({
      method: "get",
      url: `/clients?page=${currentPage}&per_page=${perPage}&sort=${sort.value}&direction=${sort.direction}${
        searchValue ? `&search=${searchValue}` : ""
      }`
    });
  } catch (e) {
    console.log(e);
  }

  return response.data;
};

export const fetchCountries = async () => {
    let response;
    try {
      response = await axios({
        method: "get",
        url: `/countries`
      });
    } catch (e) {
      console.log(e);
    }

    return response.data;
};


export const fetchClient = async (id) => {
    let response;
    try {
      response = await axios({
        method: "get",
        url: `/clients/${id}`
      });
    } catch (e) {
      console.log(e);
    }

    return response.data;
  };

export const createClient = async client => {
  let response = await axios({
    method: "post",
    url: `/clients`,
    data: client
  });
  return response.data;
};

export const editClient = async (client) => {
    let response = await axios({
        method:'put',
        url:`/clients/${client.id}`,
        data: { name: client.name, country_code: client.country_code }
    })
    return response.data
}
